var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DashboardHomeViewDebug"},[_c('div',[_vm._v("Hi from DashboardHomeView")]),_c('div',[_vm._v("Show get-started-popup")])])}]

export { render, staticRenderFns }